import axios from "../axios";
import { LOGIN_URI, LOGOUT_URI, VALIDATE_TOKEN_URI } from "../constants/uri";
import { responseHandler, errorHandler } from "../utils/handlers";

/**
 * Sign in users to applicataions
 * @param  {*}  { email, password }
 * @return {Promise} AxiosResponse with user details
 */
export const signIn = ({ email = "", password = "" }) => {
  return axios
    .post(LOGIN_URI, {
      email,
      password,
    })
    .then(responseHandler)
    .catch(errorHandler);
};

/**
 * Sign out users to applicataions
 * @return {Promise} AxiosResponse with user details
 */
export const signOut = () => {
  return axios
    .delete(LOGOUT_URI)
    .then(responseHandler)
    .catch(errorHandler);
};

/**
 * Validate current user session
 * @return {Promise} AxiosResponse with user details
 */
export const validateSession = () => {
  return axios
    .get(VALIDATE_TOKEN_URI)
    .then(responseHandler)
    .catch(errorHandler);
};
